import { render } from "./Vote.vue?vue&type=template&id=c6323e4c"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"

import "./Vote.vue?vue&type=style&index=0&id=c6323e4c&lang=postcss"
script.render = render

export default script